import { apiService } from "./apiService";
import { IServiceStatusRequest, IServiceStatusResponse } from "../types/serviceStatus";

export const ServiceStatus = {
    getLogs: (request: IServiceStatusRequest, type: "rek" | "etl"): Promise<IServiceStatusResponse> => {
        return apiService.post('/api/status', {
            search: request,
            type
        }).then(response => {
            return response.data && response.data.logs ? response.data.logs as IServiceStatusResponse : {
                total: 0,
                results: []
            };
        });
    }
}


// WEBPACK FOOTER //
// ./src/share/services/serviceStatus.ts